import { render, staticRenderFns } from "./AnchorLinkComponent.vue?vue&type=template&id=bae9cc00&"
import script from "./AnchorLinkComponent.vue?vue&type=script&lang=js&"
export * from "./AnchorLinkComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnchorLinkComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports